import { setBusinesses, setSelectedBusiness } from "../slices/business.slice";
import { ENDPOINT, STATUS } from "../../constants/server/api";
import { fetchApiData } from "../../utils/apiUtils";

export const getAllBusinesses = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.BUSINESS}/list`,
    dispatch,
  });
  if (data?.businesses) {
    dispatch(setBusinesses(data.businesses));
  }
};

export const getBusinessById = (businessId) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.BUSINESS}/${businessId}`,
    dispatch,
  });
  if (data) {
    dispatch(setSelectedBusiness(data));
    return data;
  }
};

export const getBusinessBySlug = (businessSlug) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.BUSINESS}/slug/${businessSlug}`,
    dispatch,
  });
  if (data) {
    dispatch(setSelectedBusiness(data));
    return data;
  }
};

export const createBusiness = (businessData) => async (dispatch) => {
  await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.BUSINESS}/create`,
    data: businessData,
    dispatch,
  });
  return STATUS.OK;
};

export const deleteBusiness = (businessId) => async (dispatch) => {
  await fetchApiData({
    method: "delete",
    endpoint: `${ENDPOINT.BUSINESS}/delete/${businessId}`,
    dispatch,
  });
  return STATUS.OK;
};

export const login = (businessSlug, email, password) => async (dispatch) => {
  const data = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.BUSINESS_AUTH}/login`,
    data: { businessSlug, email, password },
    dispatch,
  });

  if (data) {
    return STATUS.OK;
  }
};

export const getBusinessListBranch = (businessId) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.BUSINESS}/${businessId}`,
    dispatch,
  });
  return data;
};
